
import BarChartOutlinedIcon from '@material-ui/icons/BarChartOutlined';
// import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
// import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import TrendingUpOutlinedIcon from '@material-ui/icons/TrendingUpOutlined';
import {
    Box, Button,
    Card,
    CardContent,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Alert as MuiAlert,
    Snackbar,
    TextField, Typography
} from '@mui/material';
import { useState } from 'react';
const features = [
    { icon: DescriptionOutlinedIcon, title: 'Choose Content', description: 'Select from our extensive question bank or upload your own custom content', color: 'linear-gradient(to bottom right, #3c83f6, #6da2f8);' },
    { icon: SettingsOutlinedIcon, title: 'Customize Tests', description: 'Create topic-wise, section-wise, or full-length test series tailored to your needs', color: 'linear-gradient(to bottom right, #7c3bed, #7c3bedb3);' },
    { icon: CalendarTodayOutlinedIcon, title: 'Publish & Schedule', description: 'Set schedules, assign to students, and go live in just a few clicks', color: 'linear-gradient(to bottom right, #f59f0a, #f8bc54);' },
    { icon: TrendingUpOutlinedIcon, title: 'Track & Optimize', description: 'Monitor performance, gather insights, and continuously improve your offerings', color: 'linear-gradient(to bottom right, #10b77f, #10b77fb3);' },
];

const TestSeriesSection = ({ isLoggedIn, setShowForm }) => {

    const [loading, setLoading] = useState(false)

    const [openForm, setOpenForm] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [open, setOpen] = useState(false);
    const [showError, setShowError] = useState([]);
    const [severty, setSeverty] = useState('warning');
    const [loadingSignUp, setSignUpLoading] = useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpen(false);
        setShowError("");
    };
    const onNextHandle = async () => {
    };

    const handleSubmit = async () => {
    };

    return (
        <Box
            id="predictor"
            sx={{
                position: "relative",
                py: { xs: 6, md: 8 },
                bgcolor: "white",
                overflow: "hidden",
            }}
        >
            {/* Background Circles */}
            <Box
                sx={{
                    position: "absolute",
                    top: -100,
                    left: -100,
                    width: 300,
                    height: 300,
                    borderRadius: "50%",
                    backgroundColor: "primary.main",
                    opacity: 0.1,
                    filter: "blur(100px)",
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    bottom: -100,
                    right: -100,
                    width: 300,
                    height: 300,
                    borderRadius: "50%",
                    backgroundColor: "secondary.main",
                    opacity: 0.1,
                    filter: "blur(100px)",
                }}
            />

            <Box sx={{ position: "relative", zIndex: 2, px: 2, maxWidth: 1200, mx: "auto" }}>
                <Grid container spacing={6}>
                    {/* LEFT SECTION */}
                    <Grid item xs={12} md={6}>
                        <Box sx={{
                            display: "inline-flex", alignItems: "center", gap: 1.5, mb: 2, bgcolor: "#7c3bed1a", px: 2, py: 1, borderRadius: 5,
                        }}>
                            {/* <WhatshotOutlinedIcon size={20} color="#1976d2" /> */}
                            <img
                                src="/ruppwithbag-removebg-preview.PNG"   // put image in public folder
                                alt="Money Bag"
                                style={{ width: 20, height: 20 }}
                            />
                            <Typography sx={{ fontSize: '0.875rem', lineHeight: '1.25rem', color: '#7c3bed', fontWeight: '600', fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"', }} fontWeight={600}>
                                Featured Opportunity
                            </Typography>
                        </Box>

                        <Typography
                            variant="h3"
                            sx={{
                                fontSize: '3rem',
                                textAlign: 'left',
                                fontWeight: 700,
                                mb: 2,
                                // lineHeight: 1,
                                // color: "#242e42",
                                // fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                lineHeight: 1.2,
                                color: "#242e42",
                                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                                background: "linear-gradient(to right,hsl(38 92% 50%), hsl(262 83% 58%))",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                            }}
                        >
                            Launch Your Own Test Series!

                        </Typography>

                        <Typography variant="h6" mb={4} sx={{ fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"', color: '#65758b', fontWeight: '400', fontSize: '0.98rem', lineHeight: '1.625rem', color: '#6c7993', textAlign: 'left', textTransform: 'none' }}>
                            <Box component="span" sx={{ color: "hsl(262 83% 58%)", fontWeight: '600' }}>Start instantly with our ready-made question bank</Box> — no setup hassle. Transform your educational content into a revenue-generating platform with minimal effort.
                        </Typography>

                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                            {[
                                {
                                    icon: <CheckCircleOutlinedIcon sx={{ color: '#13ACCA', fontSize: '2rem' }} />,
                                    title: "Instant Setup",
                                    desc: "Access comprehensive question banks across engineering and medical streams. Start publishing within minutes.",
                                    bgcolor: '#05a7c71a'
                                },
                                {
                                    icon: <TrendingUpOutlinedIcon sx={{ color: "#FFCD35", fontSize: '2rem' }} />,
                                    title: "Grow Your Reach & Revenues",
                                    desc: "Publish your test series, expand your student base, and create sustainable revenue streams effortlessly.",
                                    bgcolor: '#ffcc331a'
                                },
                                // {
                                //     icon: <AssistantIcon sx={{ color: "#F4743D", fontSize: '2rem' }} />,
                                //     title: "Strategic College Planning",
                                //     desc: "Optimize your college admission strategy.",
                                //     bgcolor: '#e7eff5'
                                // },
                                {
                                    icon: <BarChartOutlinedIcon sx={{ color: "#F4743D", fontSize: '2rem' }} />,
                                    title: "System-Driven Feedback",
                                    desc: "Get intelligent comparisons and analytics to continuously improve your content quality and student outcomes.",
                                    bgcolor: '#f46d341a'
                                },
                            ].map((item, i) => (
                                <Box key={i} sx={{ display: "flex", gap: 2, textAlign: 'left' }}>
                                    <Box
                                        sx={{
                                            p: 1,
                                            borderRadius: "50%",
                                            bgcolor: item.bgcolor, //"grey.100",
                                            height: 36,
                                            width: 36,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {item.icon}
                                    </Box>
                                    <Box>
                                        <Typography fontWeight={600} sx={{
                                            fontWeight: 600,
                                            fontSize: '0.875rem',
                                            lineHeight: '1.25rem',
                                            color: '#242e42'
                                        }}>{item.title}</Typography>
                                        <Typography variant="body2" sx={{
                                            fontWeight: 400,
                                            fontSize: '0.875rem',
                                            lineHeight: '1.25rem',
                                            color: '#52667a',
                                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                        }}>
                                            {item.desc}
                                        </Typography>
                                    </Box>
                                </Box>
                            ))}
                        </Box>

                        <Button
                            variant="contained"
                            size="large"
                            // endIcon={<CheckCircleOutlinedIcon />}
                            sx={{
                                mt: 4,
                                borderRadius: 3,
                                textTransform: "none",
                                fontWeight: 600,
                                background: 'linear-gradient(135deg, hsl(16 100% 62%) 0%, #f59f0a 100%)',
                                color: '#fff',
                                float: 'left',
                                fontSize: '0.875rem',
                                lineHeight: '1.25rem',

                            }}
                            onClick={setShowForm}
                        >
                            {loadingSignUp ? 'Loading...' : '🚀 Start Your Test Series Now'}
                        </Button>
                    </Grid>

                    {/* RIGHT SECTION */}
                    <Grid item xs={12} md={6} alignContent={'center'}>
                        <Grid container spacing={2}>
                            {features.map((feature, index) => (
                                <Grid item xs={12} md={6} lg={6} key={index}>
                                    <Card sx={{
                                        textAlign: 'left',
                                        boxShadow: 'none',
                                        borderRadius: '1rem',
                                        height: '100%',
                                        transition: 'all 0.3s ease',
                                        border: '1px solid #d1d9e0',
                                        '&:hover': {
                                            transform: 'translateY(-8px)',
                                            boxShadow: 6
                                        }
                                    }}>
                                        <CardContent sx={{ p: 2 }}>
                                            <Box sx={{ width: 41, height: 41, borderRadius: 2, background: `${feature.color}`, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3, transition: 'transform 0.3s ease', '&:hover': { transform: 'scale(1.1)' } }}>
                                                <feature.icon htmlColor="#fff" sx={{ fontSize: 28 }} />
                                            </Box>
                                            <Typography variant="h5"
                                                sx={{
                                                    // mb: 2,
                                                    fontWeight: 600,
                                                    fontSize: '1rem',
                                                    lineHeight: '2rem',
                                                    color: '#0f1a24',
                                                    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                                }}>
                                                {feature.title}
                                            </Typography>
                                            <Typography color="text.secondary"
                                                sx={{
                                                    fontWeight: 400,
                                                    fontSize: '0.75rem',
                                                    lineHeight: '1.25rem',
                                                    color: '#52667a',
                                                    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                                                }}>
                                                {feature.description}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={open} onClose={handleClose} autoHideDuration={3000}>
                <MuiAlert
                    severity={severty} //"error"
                    onClose={handleClose}
                    sx={{
                        fontSize: "15px",
                        width: "100%",
                        //  backgroundColor: '#f69d9dff', 
                        color: '#000'
                    }}
                >
                    {showError}
                </MuiAlert>
            </Snackbar>
            <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="sm" fullWidth>
                <DialogTitle
                    sx={{
                        fontWeight: 700,
                        fontSize: "1.8rem",
                        fontFamily:
                            'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                        backgroundColor: "#0B3054", // dark blue
                        color: "#fff",
                        textAlign: "left",
                        py: 2,
                        display: 'inline-flex',
                        alignItem: 'center'
                    }}
                >
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, hsl(38 100% 50%), hsl(14 100% 60%))', // orange background
                            borderRadius: 2,
                            width: 42,
                            height: 42,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: '1rem'
                        }}
                    >
                        <DescriptionOutlinedIcon sx={{ color: "#0B3054", fontSize: '2.5rem' }} />
                    </Box>
                    <Box>
                        Get Your College List
                    </Box>
                </DialogTitle>

                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    {/* Subtext */}
                    <Typography
                        variant="body1"
                        sx={{
                            mb: 2,
                            textAlign: "left",
                            fontSize: "2rem",
                            color: "#4a4a4a",
                            fontWeight: '600',
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                        }}
                    >
                        Get your college list by email—just fill in your details.
                    </Typography>
                    <TextField
                        label="Name"
                        fullWidth
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        sx={{
                            mb: 1,
                            fontSize: "1.1rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }}
                        InputProps={{ style: { fontSize: "1.5rem" } }}
                    />

                    <TextField
                        label="Email"
                        type="email"
                        required
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{
                            mb: 1,
                            fontSize: "1.1rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }}
                        InputProps={{ style: { fontSize: "1.5rem" } }}
                    />

                    <TextField
                        label="Mobile"
                        fullWidth
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        sx={{
                            mb: 1,
                            fontSize: "1.1rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                        }}
                        InputProps={{ style: { fontSize: "1.5rem" } }}
                    />

                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 3 }}>
                    <Button
                        onClick={() => setOpenForm(false)}
                        variant="outlined"
                        // sx={{ textTransform: "none" }}
                        // variant="contained"
                        size="large"
                        sx={{
                            mt: 2,
                            borderRadius: 3,
                            border: '1px solid #0B3054',
                            textTransform: "none",
                            fontWeight: 600,
                            padding: '0.75rem 2rem',
                            fontSize: '1.4rem',
                            color: '#0B3054',
                            // background: '#0B3054',
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        size="large"
                        disabled={loading}
                        sx={{
                            mt: 2,
                            borderRadius: 3,
                            textTransform: "none",
                            fontWeight: 600,
                            padding: '0.75rem 2rem',
                            fontSize: '1.4rem',
                            color: '#fff',
                            background: '#0B3054',
                            '&:disabled': { backgroundColor: '#0B3054a1' }
                        }}
                        onClick={() => handleSubmit()}
                    >
                        {loading ? 'Loading...' :
                            "Submit"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};
export default TestSeriesSection;


